<div id="footer-container">
  <div class="py-3 d-flex flex-column align-items-center mh-text-on-dark-bg">
    <img src="{{footerContents.logoPath}}" alt="{{footerContents.altText}}" class="py-2 img-fluid height-65" />
    <p id="footer-copyright-text" class="text-center pt-2 text-white font-size-12 mb-1">
      <span> &#169; {{copyText}}</span>
      <a href="{{footerContents.agreementLink}}" target="_blank" class="mh-link-on-dark-bg text-decoration-underline">{{footerContents.agreement}}</a>
    </p>
  </div>
</div>
